module.exports = __webpack_public_path__ + "static/media/standing-up-man-copy-14.457eef7b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/standing-up-man-copy-14.svg
// module id = 2632
// module chunks = 0